export default Object.freeze({
  INIT: 'INIT',
  LOADING: 'LOADING',
  ERROR: 'ERROR',
  LOADED: 'LOADED'
})
